<script>
import EditView from '../base/EditView.vue'
import FormInput from '../form/form-input.vue'
import FormDatepicker from '../form/form-datepicker.vue'
export default {
  components: {
    EditView,
    FormInput,
    FormDatepicker,
  },

}
</script>
<template>
  <edit-view store="taxrate" list-route="TaxRateList" v-slot:default="slotProps">
    <form-input :store="slotProps.store" prop-name="name" class="col-4"></form-input>
    <form-input :store="slotProps.store" prop-name="taxRate" class="col-4"></form-input>
    <form-datepicker :store="slotProps.store" :translation-root="slotProps.translationRoot" prop-name="validFrom" format="YYYY-MM-DD" class="col-3"></form-datepicker>
    <form-datepicker :store="slotProps.store" :translation-root="slotProps.translationRoot" prop-name="validTo" format="YYYY-MM-DD" class="col-3"></form-datepicker>

  </edit-view>
</template>

